import {
  LayoutOutlined,
  FileDoneOutlined,
  RobotOutlined,
  // CompassOutlined,
  InfoCircleOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import _ from 'lodash';

const paymentsNavTree = [{
  key: 'payments-group',
  path: `${APP_PREFIX_PATH}/payments-group`,
  title: 'sidenav.paymentsGroup',
  fromBackend: '',
  navItem: true,
  icon: LayoutOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'payments',
      path: `${APP_PREFIX_PATH}/payments`,
      title: 'sidenav.payments',
      fromBackend: 'Payments',
      navItem: true,
      icon: LayoutOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'payments-paymentsList',
          path: `${APP_PREFIX_PATH}/payments`,
          title: 'sidenav.payments.paymentsList',
          fromBackend: 'Payments',
          navItem: false,
          icon: FileDoneOutlined,
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'payments-paymentAccount',
          path: `${APP_PREFIX_PATH}/payments/payment-account`,
          title: 'sidenav.payments.paymentAccount',
          fromBackend: 'Payment Accounts',
          navItem: false,
          icon: FileDoneOutlined,
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'libraries-delivery-tariff-template',
          path: `${APP_PREFIX_PATH}/libraries/delivery-tariff-template`,
          title: 'sidenav.libraries.deliveryTariffTemplate',
          // addClassName: 'menu-item-green',
          fromBackend: 'Customer Pricing Tiers',
          navItem: false,
          icon: FileDoneOutlined,
          breadcrumb: false,
          submenu: []
        },
      ]
    },
  ]
}]

const shippingNavTree = [
    {
      key: 'shippingList',
      path: `${APP_PREFIX_PATH}/shipping/shipping-list`,
      title: 'sidenav.shipping.shippingList',
      fromBackend: 'Shipping List',
      navItem: false,
      icon: FileDoneOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'shippingHistoryList',
      path: `${APP_PREFIX_PATH}/shipping-history/shipping-history-list`,
      title: 'sidenav.shipping.shippingHistoryList',
      fromBackend: 'Shipping History',
      navItem: false,
      icon: FileDoneOutlined,
      breadcrumb: false,
      submenu: []
    }
]

const usersNavTree = [{
  key: 'users-group',
  path: `${APP_PREFIX_PATH}/users-group`,
  title: 'sidenav.usersGroup',
  fromBackend: '',
  navItem: true,
  icon: LayoutOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'users',
      path: `${APP_PREFIX_PATH}/users`,
      title: 'sidenav.users',
      fromBackend: 'Users',
      navItem: true,
      icon: LayoutOutlined,
      breadcrumb: false,
      submenu: [
        {
            key: 'users-customers-list',
            path: `${APP_PREFIX_PATH}/users/customers`,
            title: 'sidenav.users.customers.list',
            fromBackend: 'Customers',
            navItem: false,
            icon: RobotOutlined,
            breadcrumb: false,
            submenu: []
        },
        {
          key: 'users-managers-list',
          path: `${APP_PREFIX_PATH}/users/managers`,
          title: 'sidenav.users.managers.list',
          fromBackend: 'Managers',
          navItem: false,
          icon: RobotOutlined,
          breadcrumb: false,
          submenu: []
        },
      ]
    },
  ]
}];

const toolsNavTree = [{
  key: 'tools-group',
  path: `${APP_PREFIX_PATH}/tools-group`,
  title: 'sidenav.toolsGroup',
  fromBackend: '',
  navItem: true,
  icon: false,
  breadcrumb: false,
  submenu: [
    {
      key: 'tools',
      path: `${APP_PREFIX_PATH}/tools`,
      title: 'sidenav.tools',
      fromBackend: 'Users',
      navItem: true,
      icon: InfoCircleOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'calculator',
          path: `${APP_PREFIX_PATH}/tools/calculator`,
          title: 'sidenav.tools.calculator',
          fromBackend: 'show_calculator',
          navItem: false,
          icon: false,
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'title-check',
          path: `${APP_PREFIX_PATH}/tools/title-check`,
          title: 'sidenav.tools.titleCheck',
          fromBackend: '',
          navItem: false,
          icon: false,
          breadcrumb: false,
          submenu: []
        },
        // {
        //   key: 'instructions-templates',
        //   path: `${APP_PREFIX_PATH}/tools/instructions-templates`,
        //   title: 'sidenav.tools.instructionsTemplates',
        //   fromBackend: '',
        //   navItem: false,
        //   icon: false,
        //   breadcrumb: false,
        //   submenu: []
        // },
      ],
    }
  ]
}];

const carfaxNavTree = [{
  key: 'carfax',
  path: `${APP_PREFIX_PATH}/carfax`,
  title: 'sidenav.carfax',
  fromBackend: 'show_carfax',
  navItem: false,
  icon: LayoutOutlined,
  breadcrumb: false,
  submenu: []
}];

const helpDeskNavTree = [
  {
    key: 'helpDesk',
    path: `${APP_PREFIX_PATH}/help-desk/tickets`,
    title: 'sidenav.helpDesk',
    fromBackend: '',
    navItem: false,
    icon: MessageOutlined,
    breadcrumb: false,
    submenu: []
  },
];


const expeditionNavTree = [{
  key: 'expedition-group',
  path: `${APP_PREFIX_PATH}/expedition-group`,
  title: 'sidenav.expeditionGroup',
  fromBackend: '',
  navItem: true,
  icon: false,
  breadcrumb: false,
  submenu: [
    {
      key: 'expedition',
      path: `${APP_PREFIX_PATH}/expedition`,
      title: 'sidenav.expedition',
      fromBackend: '',
      navItem: true,
      icon: LayoutOutlined,
      breadcrumb: false,
      submenu: [
        {
          key: 'expedition-fromBremenRotterdam',
          path: `${APP_PREFIX_PATH}/expedition/bremen-rotterdam`,
          title: 'sidenav.expedition.fromBremenRotterdam',
          fromBackend: 'is_bremen_rotterdam',
          navItem: false,
          icon: false,
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'expedition-fromPoti',
          path: `${APP_PREFIX_PATH}/expedition/poti`,
          title: 'sidenav.expedition.fromPoti',
          fromBackend: 'is_poty',
          navItem: false,
          icon: false,
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'expedition-fromKlaipeda',
          path: `${APP_PREFIX_PATH}/expedition/klaipeda`,
          title: 'sidenav.expedition.fromKlaipeda',
          fromBackend: 'is_klaipeda',
          navItem: false,
          icon: false,
          breadcrumb: false,
          submenu: []
        },
      ]
    }
  ]
}];



// const librariesNavTree = [{
//   key: 'libraries-group',
//   path: `${APP_PREFIX_PATH}/libraries-group`,
//   title: 'sidenav.librariesGroup',
//   fromBackend: '',
//   navItem: true,
//   icon: false,
//   breadcrumb: false,
//   submenu: [
//     {
//       key: 'libraries',
//       path: `${APP_PREFIX_PATH}/libraries`,
//       title: 'sidenav.libraries',
//       fromBackend: 'Libraries',
//       navItem: true,
//       icon: CompassOutlined,
//       breadcrumb: false,
//       submenu: [
//         {
//           key: 'libraries-tariff-template',
//           path: `${APP_PREFIX_PATH}/libraries/tariff-template`,
//           title: 'sidenav.libraries.tariffTemplate',
//           fromBackend: 'Tariffs Template',
//           navItem: false,
//           icon: false,
//           breadcrumb: false,
//           submenu: []
//         },
//       ]
//     }
//   ]
// }]

const navigationConfig = [
  ...shippingNavTree,
  ...usersNavTree,
  ...paymentsNavTree,
  ...expeditionNavTree,
  ...toolsNavTree,
  ...carfaxNavTree,
  ...helpDeskNavTree,
  // ...librariesNavTree,
]

export default navigationConfig;


export const getNavigationConfig = (navigationConfig, navPermissions) => {

  const newNavigationConfig = _.cloneDeep(navigationConfig);

  const markNavigationConfig = (searchBackendName, searchParentBackendName='' ) => {

    const markingProcess = (navigationConfig, parentItemNavigation='') => {
      // console.log('markNavigationConfig->',
      //   'searchBackendName:', searchBackendName,
      //   'searchParentBackendName:',searchParentBackendName,
      //   'parentItemNavigation:', parentItemNavigation,
      //   'newNavigationConfig:', navigationConfig)

      navigationConfig.forEach((item) => {
        if (((parentItemNavigation === searchParentBackendName ||
          (parentItemNavigation?.includes && parentItemNavigation.includes(searchParentBackendName))) && item?.fromBackend === searchBackendName) || item?.navItem === true) {
          item.isLeave = true;
        }
        // if (item?.key === 'helpDesk' || item?.key === 'helpDeskAudit' || item?.key === 'assignee-category') {
        //   item.isLeave = true;
        // }
        // if (item?.key === 'export-carfax-report') {
        //   item.isLeave = true;
        // }

        // if (item?.key === 'libraries-auction-account') {
        //   item.isLeave = true;
        // }

        if (item?.key === 'calculator') {
          item.isLeave = true;
        }
        if (item?.key === 'title-check') {
          item.isLeave = true;
        }
        if (item?.key === 'instructions-templates') {
          item.isLeave = true;
        }
        if (item?.key === 'export-delivery-to-port-price') {
          item.isLeave = true;
        }

        if (item?.key === 'carfax') {
          item.isLeave = true;
        }

        if (item?.key === 'helpDesk') {
          item.isLeave = true;
        }

        if (item?.key === 'tempTest') {
          item.isLeave = true;
        }

        markingProcess(item.submenu, item?.fromBackend ?? '');
      })
    }

    markingProcess(newNavigationConfig);

  }

  const iteratePermissions = (navPermissions, parentItemPermission='') => {

    for (let itemPermission in navPermissions) {

      if( navPermissions.hasOwnProperty(itemPermission)) {

        markNavigationConfig(itemPermission.trim(), parentItemPermission);

         // console.log('parentItemPermission:', parentItemPermission, 'itemPermission:',itemPermission)
        if( typeof navPermissions[itemPermission] === 'object' ) {
          iteratePermissions(navPermissions[itemPermission], itemPermission.trim());
        }

      }

    }

  }

  const filterAllowedNavigationConfig = (newNavigationConfig) => {
    const result = [];
    let subMenu;
    let newItem;
    for(let i = 0; i < newNavigationConfig.length; i++) {
      if (_.isObject(newNavigationConfig[i]) && newNavigationConfig[i]?.isLeave === true ) {
        subMenu = [];

        if (newNavigationConfig[i]?.submenu !== undefined &&
            _.isArray(newNavigationConfig[i].submenu) && !_.isEmpty(newNavigationConfig[i].submenu)) {
          subMenu = filterAllowedNavigationConfig(newNavigationConfig[i].submenu);
        }
        if (newNavigationConfig[i]?.navItem === true &&
          _.isEmpty(subMenu)) {
          continue;
        }

        newItem = {...newNavigationConfig[i]};
        if (!_.isEmpty(subMenu)) {
          newItem.submenu = subMenu;
        }

        // console.log('newNavigationConfig[i]:',newNavigationConfig[i])
        result.push(newItem);
      }
    }
    return result;
  }

  iteratePermissions(navPermissions)

  // console.log('newNavigationConfig:', newNavigationConfig);

  return filterAllowedNavigationConfig(newNavigationConfig);
}


